import {
  Users,
  Smartphone,
  Globe,
  MessageSquare,
  Mic,
  Box,
  Zap,
  Shield,
  BarChart,
  Heart,
  type LucideIcon,
} from 'lucide-react';
import { cn } from '@/lib/utils';

const iconMap: Record<string, LucideIcon> = {
  users: Users,
  smartphone: Smartphone,
  globe: Globe,
  'message-square': MessageSquare,
  mic: Mic,
  box: Box,
  zap: Zap,
  shield: Shield,
  'bar-chart': BarChart,
  heart: Heart,
};

interface ServiceIconProps {
  icon: string;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export function ServiceIcon({ icon, size = 'md', className }: ServiceIconProps) {
  const Icon = iconMap[icon] || Box;

  const sizes = {
    sm: 'w-5 h-5',
    md: 'w-6 h-6',
    lg: 'w-8 h-8',
  };

  return <Icon className={cn(sizes[size], className)} />;
}

interface ServiceIconBoxProps {
  icon: string;
  size?: 'sm' | 'md' | 'lg';
  variant?: 'default' | 'primary';
  className?: string;
}

export function ServiceIconBox({ icon, size = 'md', variant = 'default', className }: ServiceIconBoxProps) {
  const boxSizes = {
    sm: 'w-10 h-10',
    md: 'w-12 h-12',
    lg: 'w-16 h-16',
  };

  const iconSizes = {
    sm: 'sm' as const,
    md: 'md' as const,
    lg: 'lg' as const,
  };

  const variants = {
    default: 'bg-neutral-100 dark:bg-neutral-800 text-neutral-600 dark:text-neutral-400',
    primary: 'bg-primary-100 dark:bg-primary-900/30 text-primary-600 dark:text-primary-400',
  };

  return (
    <div
      className={cn(
        'flex items-center justify-center rounded-xl',
        boxSizes[size],
        variants[variant],
        className
      )}
    >
      <ServiceIcon icon={icon} size={iconSizes[size]} />
    </div>
  );
}
